<template>
  <div class="account-appeal-success">
    <img src="../../assets/img/shensu/success3x.png" alt="">
    <p v-if="flag">申诉成功</p>
    <p v-else>提交成功，请耐心等待系统审核!</p>
    <div @click="closeWindow">
        <span>关闭页面</span>
    </div>
  </div>
</template>

<script>
  export default {
      data(){
          return {
              flag:""
          }
      },
      created(){
          this.flag = this.$route.query.flag;
      },
      methods: {
          closeWindow(){
              this.JSBridge.closeH5Window();
          }
      }
  }
</script>

<style scoped lang="less">
    .account-appeal-success{
        width: 100%;
        text-align: center;
        padding-top: 20%;
        img{
            width: 24%;
        }
        p{
            margin-top: 10px;
            font-size: 0.5rem;
        }
        div{
            width: 100%;
            padding: 0px 10%;
            margin-top: 20%;
            span{
                width: 100%;
                height: 50px;
                line-height: 50px;
                font-size: 0.42rem;
                display: block;
                background-color: #0F8EE8;
                color: #FFFFFF;
                border-radius: 2px;
                letter-spacing: 1px;
                margin-bottom: 5px;
            }
            
        }
    }
</style>
